export default [
    {
        path: '/',
        redirect: '/home', //重定向
    },
    {
        path: "/home",
        name: "home",
        component: () => import('../views/home'),
    },
    {
        path: '/study',
        // name: '',
        component: () => import('../views/wrapper'),
        children: [
            {
                path: '',
                component: () => import('../views/study/study'),
                children: [
                    {
                        path: '',
                        name: '一级目录',
                        component: () => import('../views/study/menu'),
                    },
                    {
                        path: 'list',
                        name: '二级目录',
                        component: () => import('../views/study/list'),
                    }
                ]
            },
            {
                path: 'detail',
                name: '详情',
                component: () => import('../views/study/detail'),
            }
        ]
    },
    {
        path: '/partnership',
        // name: '',
        component: ()=> import('../views/partnership')
    },
    {
        path: '/about',
        // name: '',
        component: ()=> import('../views/about')
    },
    {
        path: '/contact',
        // name: '',
        component: ()=> import('../views/contact')
    },
    {
        path: '/login',
        component: () => import('../views/mine/login'),
    },
    {
        path: '/mine',
        // name: '',
        meta: {
            requiresAuth: true,
        },
        component: () => import('../views/mine/mine'),
        children: [
            {
                path: '',
                redirect: 'dashboard', //重定向
            },
            {
                path: 'dashboard',
                component: () => import('../views/mine/dashboard'),
            },
            {
                path: 'supportDesk',
                component: () => import('../views/mine/supportDesk'),
            },
            {
                path: 'result',
                component: () => import('../views/mine/result'),
            },
            {
                path: 'enrolledCourses',
                component: () => import('../views/mine/enrolledCourses'),
            },
            {
                path: 'files',
                component: () => import('../views/mine/files'),
            },
            {
                path: 'settings',
                component: () => import('../views/mine/settings'),
                children: [
                    {
                        path: '',
                        redirect: 'profile', //重定向
                    },
                    {
                        path: 'profile',
                        component: () => import('../views/mine/profile'),
                    },
                    {
                        path: 'resetPassword',
                        component: () => import('../views/mine/resetPassword'),
                    },
                ]
            },
        ]
    },
    // {
    //     path: '/',
    //     redirect: '/home', //重定向
    // },
    // {
    //     path: '/home',
    //     name: '',
    //     component: () => import('../views/container'),
    //     children: [
    //         {
    //             path: '',
    //             name: '首页',
    //             component: () => import('../views/home/index'),
    //         },
    //         {
    //             path: 'interactiveMessageDetail',
    //             name: '互动留言详情',
    //             meta: {
    //                 requiresAuth: true,
    //                 title: '互动留言'
    //             },
    //             // redirect: '/none'
    //             component: () => import('../views/home/interactiveMessageDetail'),
    //         },
    //     ]
    // },
]
